<div class="modal-header-container"
     [class.green27-background]="model.alertData$()?.status === AlertStatus.CLOSED"
     [class.red4-background]="model.alertData$()?.status === AlertStatus.OPEN"
     [class.orange3-background]="model.alertData$()?.status === AlertStatus.ACKNOWLEDGED">
    <div  class="modal-title modal-title-open-close" *ngIf ="model.alertData$()?.status === AlertStatus.OPEN">
      <img [src]="'assets/icons/alert-info-icon2.svg'" alt="Icon">
      {{'t.ticketStatusOpen' | translate}}
    </div>
    <div  class="modal-title modal-title-open-close" *ngIf ="model.alertData$()?.status === AlertStatus.CLOSED">{{'t.alertMonitorStateClosed' | translate}}</div>
    <div  class="modal-title modal-title-acknowledged" *ngIf ="model.alertData$()?.status === AlertStatus.ACKNOWLEDGED">
      <img [src]="'assets/icons/alert-info-icon.svg'" alt="Icon">
      {{'t.alertAckStatus' | translate}}
    </div>
  <div class="pi pi-times close-icon"
       [class.modal-title-acknowledged]="model.alertData$()?.status === AlertStatus.ACKNOWLEDGED"
       (click)="onCloseIconClicked()"></div>
  <div class="pi pi-times close-icon"
       [class.modal-title-open-close]="model.alertData$()?.status === AlertStatus.OPEN || model.alertData$()?.status === AlertStatus.CLOSED"
       (click)="onCloseIconClicked()"></div>

</div>
